import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    onLoaded (entity) {
      super.onLoaded(entity)
      if (!store.options.has('enums')) {
        store.loadOptions('enums', '/enums/options/', 'value')
      }
      const enumEntities = store.options.has('enums') && linkConst.REPORTS_ADD_ENTITIES.concat(store.options.get('enums'))
      store.options.set('enumEntities', enumEntities)
    }

    beforeSave (entity) {
      entity.updated_at = new Date()
      super.beforeSave(entity)
    }

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty('reports')
      store.markDirty('filterParameters')
      store.markDirty('reports4filter')
    }

    prepareNew () {
      this.record.set('parameters', [])
    }

    requiredOptions = [
      'FieldTypes',
      'Platforms',
      linkConst.LOAD_OPTIONS.enums
    ]

    subentities = {
      parameters: store.createEmbededEntityState({
        attrs: [
          'parameter_title', 'parameter_number', 'type', 'options_attr'
        ],
        titles: [
          store.__('parameter title'), store.__('parameter number'), store.__('type'), store.__('options atribute')
        ],
        _sortField: 'parameter_number',
        validators: {
          parameter_title: Validators.isMandatory(store),
          parameter_number: [
            Validators.isMandatory(store),
            Validators.positiveInt(store)
          ],
          type: Validators.isMandatory(store),
          _global: (vals) => {
            // Do not alow user to select options while select type is not chosen
            if (vals.has('type') && !['select', 'multiselect'].includes(vals.get('type'))) {
              vals.set('options_attr', null)
            }
          }
        }
      })
    }

    createtitle = store.__(linkConst.LINK_REPORTS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_REPORTS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    validators = {
      name: Validators.isMandatory(store),
      owned_by: Validators.isMandatory(store),
      query: val => {
        if (val && !val.match(/^([\s]*)(\(?)(select|call)([\s]+)/gi)) {
          return 'Query has to begin with keyword SELECT or CALL.'
        }
      },
      _global: (vals) => {
        const type = store.cv.record.get('type')
        const l = store.cv.record.get('link')
        const q = store.cv.record.get('query')

        if (type === 'extern') {
          if (!l) { return [store.__('Link is mandatory')] }
        } else {
          if (!q) { return [store.__('Query is mandatory')] }
        }
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'name',
      'link',
      'query',
      'purpose',
      'owned_by',
      'entity_filter',
      'type'
    ]

    noSort = ['query']
    headertitles = [
      store.__('ID'),
      store.__('name'),
      store.__('link'),
      store.__('query'),
      store.__('purpose'),
      store.__('owner'),
      store.__('entity'),
      store.__('type')
    ]

    requiredOptions = [
      linkConst.LOAD_OPTIONS.enums
    ]

    title = store.__(linkConst.LINK_REPORTS_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_REPORTS]
  }

  return { ManipState, TableState }
}
